<div class="modal-header">
  <h4 class="modal-title">
    {{'projectRequestPopup.title' | translate}}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <h2>{{getHeader()}}</h2>
    <p class="font-weight-bold">{{'projectRequestPopup.label.prompt_to_enter_request_data' | translate}}</p>
    <form class="form-horizontal" [formGroup]="form" novalidate>
      <div class="row">
        <div class="mb-3 col-sm-4">
          <label for="ang-1">{{'projectRequestPopup.label.total_demand' | translate}} *</label>
          <input class="form-control" id="ang-1" type="text" inputRestricter="^([1-9][0-9]{0,7})?$"
            formControlName="totalDemand" [class.is-invalid]="checkControlValidity('totalDemand')">
          <div class="invalid-feedback">{{form.controls.totalDemand.errors?.messageKey | translate}}</div>
        </div>
        <div class="mb-3 col-sm-4">
          <label for="ang-2">{{'projectRequestPopup.label.batch_size' | translate}} *</label>
          <input class="form-control" id="ang-2" type="text" inputRestricter="^([1-9][0-9]{0,7})?$"
            formControlName="batchSize" [class.is-invalid]="checkControlValidity('batchSize')">
          <div class="invalid-feedback">{{form.controls.batchSize.errors?.messageKey | translate}}</div>
        </div>
        <div class="mb-3 col-sm-4">
          <label for="ang-3">{{'projectRequestPopup.label.desired_delivery_date' | translate}}</label>
          <div class="input-group">
            <input type="text" class="form-control" #dp="bsDatepicker" bsDatepicker [bsValue]="bsValue"
              [minDate]="startDate" [maxDate]="endDate" formControlName="deliveryDate">
            <span class="input-group-append">
              <button class="btn btn-secondary" type="button" (click)="dp.toggle()">
                <app-svg-icon type="calendar"/>
              </button>
            </span>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="mb-3 col-md-12">
          <label for="ang-4">{{'projectRequestPopup.label.remarks' | translate}}</label>
          <textarea name="" id="ang-4" class="form-control" rows="3" maxlength="1000" formControlName="remarks"
            [class.is-invalid]="checkControlValidity('remarks')"></textarea>
          <div class="invalid-feedback">{{form.controls.remarks.errors?.messageKey | translate}}</div>
        </div>
      </div>
      <div class="row">
        <div class="mb-3 col-sm-6">
          <label for="sapProjectNumber">{{'projectRequestPopup.label.sap_project_nr' | translate}}</label>
          <input class="form-control" id="sapProjectNumber" type="text" inputRestricter="^([0-9]{0,8})?$"
            formControlName="sapProjectNumber" [class.is-invalid]="checkControlValidity('sapProjectNumber')">
          <div class="invalid-feedback">{{form.controls.sapProjectNumber.errors?.messageKey | translate}}</div>
        </div>
      </div>
      <div>
        <p class="middle">
          {{'projectRequestPopup.message.mail_edit_notice' | translate}}
        </p>
        <p class="middle ms-0_75">
          {{getEmailByProjectType()}}
        </p>
        <div *ngFor="let element of [].constructor(ADDITIONAL_EMAILS_COUNT); let i = index" class="row">
          <div class="mb-3 col-sm-10 d-flex">
            <div class="input-group">
              <input class="form-control" id="mail-3" type="text" [formControlName]="'email' + i"
                [class.is-invalid]="checkControlValidity('email' + i, true) || checkControlValidity('emailCheckbox' + i, true)"
                spellcheck="false" (input)="this.resetCheckbox(form.controls['emailCheckbox' + i])"
                (blur)="markControlAsDirty('email' + i)">
              <div class="invalid-feedback">{{form.controls['email' + i].errors?.messageKey | translate}}</div>
              <div class="invalid-feedback">{{form.controls['emailCheckbox' + i].errors?.messageKey | translate}}</div>
            </div>
          </div>
          <div *ngIf="showCheckbox(form.controls['email' + i], form.controls['emailCheckbox' + i])">
            <div class="form-check mt-1">
              <input class="form-check-input form-control" [formControlName]="'emailCheckbox' + i"
                [id]="'emailCheckbox' + i" type="checkbox" (blur)="markControlAsDirty('emailCheckbox' + i)">
              <label [for]="'emailCheckbox' + i" class="form-check-label"></label>
            </div>
          </div>
        </div>
     </div>
      <p *ngIf="showMcsGdsInfo()">{{'requestFinalizeProject.mcsGdsInfo.text' | translate}}</p>
      <div class="row">
        <div class="mb-3 col-md-12">
          <label>* = {{'global.label.legend_required_field' | translate}}</label>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" id="cancel" class="btn btn-secondary btn-cancel" (mousedown)="$event.preventDefault();"
    (click)="preventValidationOnClose(); close(false)">{{'global.label.cancel' | translate}}</button>
  <button type="submit" id="submit" class="btn btn-primary" (click)="submit()">
    <app-svg-icon type="list" size="medium-small"/>
    <span>{{'projectRequestPopup.label.request_project' | translate}}</span>
  </button>
</div>
